import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import * as moment from 'moment'

@Component({
  selector: 'app-question-bank',
  templateUrl: './question-bank.component.html',
  styleUrls: ['./question-bank.component.css']
})
export class QuestionBankComponent implements OnInit {


  Submitted:boolean = false;
  BookTitleList=[];
  ChapterHeadingList=[];
  ChapterTopicList=[];
  SearchChapterHeadingList=[];
  SearchChapterTopicList=[];
  ChapterContentList=[];

  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    SearchModel = {    
     BookTitleID:0,
     ChapterID:0,
     TopicID:0,
     QuestionTypeID:0,
     CurrentIndex: 0,
     PageSize: 20,
  };

  ClearSearch(){
    this.SearchModel.BookTitleID=0;
    this.SearchModel.ChapterID=0;
    this.SearchModel.TopicID=0;
    this.SearchModel.QuestionTypeID=0;
    this.QuestionBankList=[];
    this.pageSizes();
  }
  Content: '';
  LearningModel = { 
    QuestionID:0,  
    QuestionTypeID:0,
    BookTitleID:0,
    ChapterID:0,
    TopicID:0,
    Question: "",
    QValue:0,
    Options:0,
    OP1:'',
    OP2:'',
    OP3:'',
    OP4:'',
    ROP1:false,
    ROP2:false,
    ROP3:false,
    ROP4:false, 
    RFOP1:'',
    RFOP2:'',
    RFOP3:'',
    RFOP4:'',
    IsActive: true,
    
};

  Clear() {
    this.LearningModel.QuestionID = 0;
    this.LearningModel.QuestionTypeID = 0;
    this.LearningModel.BookTitleID = 0;
    this.LearningModel.ChapterID = 0;
    this.LearningModel.TopicID = 0;
    this.LearningModel.Question = '';   
    this.LearningModel.QValue = 0;
    this.LearningModel.Options = 0;
    this.LearningModel.OP1='';
    this.LearningModel.OP2='';
    this.LearningModel.OP3='';
    this.LearningModel.OP4='';
    this.LearningModel.RFOP1='';
    this.LearningModel.RFOP2='';
    this.LearningModel.RFOP3='';
    this.LearningModel.RFOP4='';
    this.Submitted = false;
}

Edit(obj) {
  this.LearningModel.QuestionID = obj.QuestionID;
  this.LearningModel.Question = obj.Question;
  this.LearningModel.QuestionTypeID=obj.QuestionTypeID; 
  this.LearningModel.Options = obj.Options;
  this.LearningModel.QValue = obj.QValue;
  this.LearningModel.OP1 = obj.OP1;
  this.LearningModel.OP2 = obj.OP2;
  this.LearningModel.OP3 = obj.OP3;
  this.LearningModel.OP4 = obj.OP4;
  this.LearningModel.RFOP1 = obj.RFOP1;
  this.LearningModel.RFOP2 = obj.RFOP2;
  this.LearningModel.RFOP3 = obj.RFOP3;
  this.LearningModel.RFOP4 = obj.RFOP4;
  this.LearningModel.ROP1 = obj.ROP1;
  this.LearningModel.ROP2 = obj.ROP2;
  this.LearningModel.ROP3 = obj.ROP3;
  this.LearningModel.ROP4 = obj.ROP4;
  this.LearningModel.BookTitleID = obj.BookTitleID;
  this.GetChapterHeading();
  this.LearningModel.ChapterID = obj.ChapterID;
  this.GetChapterTopic();
  this.LearningModel.TopicID = obj.TopicID;
 
  this.LearningModel.IsActive = obj.IsActive;
  
}
SelectedFileForUpload:any;
selectFileforUpload(file) {
  this.SelectedFileForUpload = file[0];
};

ValidityState(){
  return this.LearningModel.QuestionTypeID==0||this.LearningModel.BookTitleID==0||this.LearningModel.Question==''|| this.LearningModel.ChapterID==0||this.LearningModel.TopicID==0 ;
}


SaveQuestionBank() {  
  this.Submitted = true;
  if (!this.ValidityState()) {
    this.spinnerService.show();
    this.learningservice.SaveQuestionBank(JSON.stringify(this.LearningModel),this.SelectedFileForUpload).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllQuestionBank();
      }
      if (data.webResponse.Status && this.LearningModel.QuestionID == 0) {
        this.Clear();
      }
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  }

};
QuestionBankList=[];
GetAllQuestionBank() {
  this.spinnerService.show();
  this.SearchModel.CurrentIndex = this.currentPage;
  this.SearchModel.PageSize = this.pageSize;
  this.learningservice.GetAllQuestionBank(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
    this.QuestionBankList = data.QuestionBankList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
    this.recordCount = 0;
    if (data.QuestionBankList != null && data.QuestionBankList.length > 0) {
        this.recordCount = data.QuestionBankList[0].RecordCount;
    }
    this.numberOfPages();
  });
};

MarkActiveQuestionBank(item) {
  this.LearningModel.QuestionID = item.QuestionID;
  this.LearningModel.IsActive = item.IsActive == true ? false : true;
  this.spinnerService.show();
  this.learningservice.MarkActiveQuestionBank(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
    if (data.webResponse.Status) {
      this.GetAllQuestionBank();
    }
   
    this.globalHelper.CheckActionStatus(data);
    this.spinnerService.hide();
  });
};

GetSingleChoice(ChoiceID){
  if(this.LearningModel.ROP1==ChoiceID){   
    this.LearningModel.ROP2=false;
    this.LearningModel.ROP3=false;
    this.LearningModel.ROP4=false;
  }
  else if(this.LearningModel.ROP2==ChoiceID){
    this.LearningModel.ROP1=false;
    this.LearningModel.ROP3=false;
    this.LearningModel.ROP4=false;
  }
  else if(this.LearningModel.ROP3==ChoiceID){
    this.LearningModel.ROP1=false;
    this.LearningModel.ROP2=false;
    this.LearningModel.ROP4=false;
  }
  else if(this.LearningModel.ROP4==ChoiceID){
    this.LearningModel.ROP1=false;
    this.LearningModel.ROP2=false;
    this.LearningModel.ROP3=false;
  }
}
GetTrueFalse(ChoiceID){
  if(this.LearningModel.ROP1==ChoiceID){   
    this.LearningModel.ROP2=false;
    
  }
  else if(this.LearningModel.ROP2==ChoiceID){
    this.LearningModel.ROP1=false;
  }
}
ValidityUpload(){
  return this.LearningModel.QuestionTypeID==0;
}
ClearQuestion(){
  this.QuestionList=[];
}
QuestionList=[];
UploadQuestionBank  () { 
  this.Submitted = true;
  this.QuestionList=[];
  if (!this.ValidityUpload()) {
      this.spinnerService.show();
      this.learningservice.UploadQuestionBank(JSON.stringify(this.LearningModel),this.SelectedFileForUpload).subscribe( (response)=> {
          this.Submitted = false;
          this.spinnerService.hide();
          this.QuestionList = response.QuestionList;
          this.globalHelper.CheckActionStatus(response);
    });
}

}

UpdateQuestionBank() {  
  this.Submitted = true;
  if (!this.ValidityUpload()) {
    this.spinnerService.show();
    this.learningservice.UpdateQuestionBank(JSON.stringify(this.LearningModel),JSON.stringify(this.QuestionList)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllQuestionBank();
      }     
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  }

};
  ngOnInit() {
    this.GetBookTitle();
    this.GetQuestionType();
    this.GetSearchChapterHeading();
    this.GetSearchChapterTopic();  

  }
  GetBookTitle() {
    this.LookupService.GetLookupsList('LearningBookTitle', '').subscribe((data: any) => {
      this.BookTitleList = data.LookupItems;
    });
  }
 
  QuestionTypeList=[];
  GetQuestionType() {
    this.LookupService.GetLookupsList('QuestionType', '').subscribe((data: any) => {
      this.QuestionTypeList = data.LookupItems;
    });
  }
 
  GetChapterHeading() {
    this.LearningModel.ChapterID=0;
    var ItemBO={
     'ItemID':this.LearningModel.BookTitleID
   }
   this.spinnerService.show();
    this.LookupService.GetLookupsList('ChapterHeading', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterHeadingList = data.LookupItems;
      this.spinnerService.hide();
    });
  }

  GetChapterTopic() {
    this.LearningModel.TopicID=0;
    var ItemBO={
     'ItemID':this.LearningModel.ChapterID
   }
   this.spinnerService.show();
    this.LookupService.GetLookupsList('ChapterTopic', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.ChapterTopicList = data.LookupItems;
      this.spinnerService.hide();
    });
  }
  GetSearchChapterHeading() {
    this.SearchModel.ChapterID=0;
    this.SearchModel.TopicID=0;
    this.ChapterContentList=[];
    var ItemBO={
     'ItemID':this.SearchModel.BookTitleID
   }
    this.LookupService.GetLookupsList('ChapterHeading', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SearchChapterHeadingList = data.LookupItems;
    });

  }

  GetSearchChapterTopic() {
    this.SearchModel.TopicID=0;
    this.ChapterContentList=[];
    var ItemBO={
     'ItemID':this.SearchModel.ChapterID
   }
    this.LookupService.GetLookupsList('ChapterTopic', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SearchChapterTopicList = data.LookupItems;
    });

  }


  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
   this.totalPages = Math.ceil(this.recordCount / this.pageSize);
   }

   nextPage() {
   this.currentPage = this.currentPage + 1;
   }

   pageSizes() {
   this.currentPage = 1;
   this.recordCount = 0;
   this.totalPages = 0;
   }


}








